import { useEffect, useState } from "react";
import CheckLogin from "../services/CheckLogin";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import PendingApproval from "../pages/auth_pages/PendingApproval";

function AuthProvider({ children, role = null }) {
     const host = `${process.env.REACT_APP_LOCAL_HOST}`;
     const [wait, setWait] = useState(true);
     const [profile, setProfile] = useState(null);
     const navigate = useNavigate();

     useEffect(() => {
          const checkLogin = async () => {
               try {
                    let result = await CheckLogin(host);
                    if (!result) {
                         navigate('/login');
                    } else {
                         if (role && result.data.account_role != role) {
                              navigate(-1);
                         }
                         setProfile(result.data);
                    }
               } catch (err) {
                    console.error(err);
                    navigate("/login");
               } finally {
                    setWait(false);
               }
          }
          checkLogin();
     }, [navigate, host, role]);

     if (!wait && profile && role === 'teacher' && profile.is_active === false) {
          return (
               <AuthContext.Provider value={{ wait, setWait, profile, setProfile }}>
                    <PendingApproval />
               </AuthContext.Provider>
          );
     }

     return (
          <AuthContext.Provider value={{ wait, setWait, profile, setProfile }}>
               {children}
          </AuthContext.Provider>
     );

}

export default AuthProvider;
